import { render, staticRenderFns } from "./OrderItemCommitmentModal.vue?vue&type=template&id=696bcfd4&"
import script from "./OrderItemCommitmentModal.vue?vue&type=script&lang=js&"
export * from "./OrderItemCommitmentModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemCommitmentModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports